// Permite que o MESMO build sirva tanto na raiz de gestao.horizonte.tec.br
// quanto sob /producao dentro do arquivos.horizonte.tec.br (reverse proxy) —
// sem precisar manter dois builds diferentes.
export const BASE_PATH =
  typeof window !== "undefined" && window.location.hostname === "arquivos.horizonte.tec.br"
    ? "/producao"
    : "";
